import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SlicePipe, TitleCasePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { SwiperOptions } from 'swiper/types/swiper-options';
import { EInfoType } from 'src/app/core/enums/country-info-type.enum';
import { Attraction } from 'src/app/core/types/models/attraction.model';

import { ReplaceStrPipe } from 'src/app/shared/pipes/replace-str.pipe';
import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { AttractionCardMobileComponent } from '../attraction-card-mobile/attraction-card-mobile.component';

const ATTRACTION_LIST_SWIPER_OPTIONS: SwiperOptions = {
  slidesPerView: 1.2,
  spaceBetween: 16,
  autoplay: false,
  breakpoints: {
    375: {
      slidesPerView: 1.2,
      spaceBetween: 16,
    },
    524: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 24,
    },
    1100: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
};

@Component({
  selector: 'app-attraction-list-mobile',
  templateUrl: './attraction-list-mobile.component.html',
  styleUrls: ['attraction-list-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    SwiperDirective,
    LocationListModule,
    TranslateModule,
    SlicePipe,
    TitleCasePipe,
    ReplaceStrPipe,
    AttractionCardMobileComponent,
  ],
})
export class AttractionListMobileComponent {
  @Input() countryName: string = '';
  @Input() attractions: Attraction[] = [];

  protected readonly swiperOptions: SwiperOptions =
    ATTRACTION_LIST_SWIPER_OPTIONS;
  protected readonly eInfoType = EInfoType;
}
